module.exports = __webpack_public_path__ + "assets/images/stopwatch.svg?04f500b54e6216154c7a89b17a0bd074";


//////////////////
// WEBPACK FOOTER
// ./_source/images/notifications/stopwatch.svg
// module id = 601
// module chunks = 0